const Backbone = require('backbone');
const Mn = require('backbone.marionette');
const Router = require('jiji/app/router/index');
const API = require('jiji/infra/api/user');
const AccountListView = require('jiji/ui/view/account/list');
const AccountRepository = require('jiji/domain/repository/account');
const Template = require('jiji/ui/template/content/connect/index.hbs');

module.exports = Mn.View.extend({
    template: Template,
    ui: {
        connectButton: '.connect'
    },
    events: {
        'click @ui.connectButton': 'connect'
    },
    regions: {
        accounts: '.accounts'
    },

    onRender: function() {
        AccountRepository.getUnconnectedAccounts().then(accounts => {
            this.showChildView('accounts', new AccountListView({
                collection: new Backbone.Collection(accounts)
            }));

            this._account = accounts[0];
        });
    },

    connect: function() {
        API.connect({
            providerName: this._account.getProviderName(),
            providerId: this._account.getProviderId()
        }).then(() => {
            location.href = '/';
        });
    }
});



// WEBPACK FOOTER //
// ./jiji/ui/view/content/connect/index.js